import logo from "./logo.svg";
import "./App.scss";
import Intercom from "react-intercom";

import SafetyAppSEO from "./Components/SEO/SafetyAppSEO";

import { Routes, Route } from "react-router-dom";

import { GetADemoPage } from "./Components/GetADemo/GetADemoPage";
import { SafetyAppPage } from "./Pages/SafetyAppPage";
import PrivacyStatement from "./Components/Privacy/PrivacyStatement";

function App() {
  return (
    <div className="App">
      <Intercom appID="g8x7nd2m" />

      <SafetyAppSEO />
      <Routes>
        <Route path="/get-a-demo" element={<GetADemoPage />} />

        <Route path="/" element={<SafetyAppPage />} />

        <Route path="/privacy-statement" element={<PrivacyStatement />} />
      </Routes>
    </div>
  );
}

export default App;
